import React from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import MainNavMenuColumn from './MainNavMenuColumn';

function MainNavMegaMenu({ columns }) {
  return (
    <div className="mainNavMegaMenu">
      {columns.map((column, index) => {
        const { columnName, menuItems } = column;

        return (
          <MainNavMenuColumn
            // eslint-disable-next-line react/no-array-index-key
            key={`${camelCase(columnName)}_column_${index}`}
            index={index}
            menuItems={menuItems}
            columnName={columnName}
          />
        );
      })}
    </div>
  );
}

MainNavMegaMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  columns: PropTypes.array,
};

export default MainNavMegaMenu;
